import type { CSS } from '../../stitches.config';
import type { SpacingScale } from './sizes';

export type MaxHeightTypes = 'full' | 'screen' | SpacingScale | string;
export type MaxHeightProps = { maxHeight?: MaxHeightTypes };

export const maxHeightCSS = (maxHeight?: MaxHeightTypes): CSS => {
  if (maxHeight === 'full' || maxHeight === '100%') {
    return { maxHeight: '100%' };
  }

  if (maxHeight === 'screen') {
    return { maxHeight: '100dvh' };
  }

  if (typeof maxHeight === 'string' && (maxHeight.includes('vh') || maxHeight.includes('dvh'))) {
    return {
      maxHeight: `${maxHeight}`,
    };
  }

  if (maxHeight != null) {
    return {
      maxHeight: `$${maxHeight}`,
    };
  }

  return {};
};
